import "./landing-page-header-item.component.scss";

export default {
    template: require('./landing-page-header-item.component.html'),
    transclude: true,
    controller: function () {
        'ngInject';
    }
};
